import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonBaseComponent } from '../button-base.component';

@Component({
  selector: 'app-button-advanced',
  templateUrl: 'button-advanced.component.html',
  styleUrls: ['button-advanced.component.scss'],
})
export class ButtonAdvancedComponent extends ButtonBaseComponent {
  @Input() displayCorner: boolean = false;
  @Input() hotButton: string = '';
  @Input() isMenuOpened: boolean = false;
  @Output() clickedByCorner: EventEmitter<MouseEvent | TouchEvent> =
    new EventEmitter<MouseEvent | TouchEvent>();

  constructor() {
    super();
  }

  onClickCorner(event: MouseEvent | TouchEvent): void {
    this.clickedByCorner.emit(event);
    event.stopPropagation();
  }
}
